import React from "react";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { useNavigate, useLocation } from "react-router-dom";

const Confirmation = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const user = state?.user;

  const goHome = () => {
    navigate("/");
  };

  const header = (
    <div className="text-center mb-3">
      <i className="pi pi-check-circle text-green-500" style={{ fontSize: "4rem" }}></i>
    </div>
  );

  return (
    <div className="flex justify-content-center align-items-center min-h-screen p-4">
      <Card
        title="Registration Successful!"
        subTitle="Your account has been created successfully."
        header={header}
        className="shadow-4 w-full md:w-5 lg:w-4"
      >
       

        <Button
          label="Go to Home"
          icon="pi pi-home"
          className="mt-4 w-full"
          onClick={goHome}
        />
      </Card>
    </div>
  );
};

export default Confirmation;
